import { CloseCircleFilled } from '@ant-design/icons';
import { Grid, ModalProps as AntModalProps } from 'antd';

import { StyledModal } from './modal.styles';

const { useBreakpoint } = Grid;

export type ModalProps = AntModalProps & { isFullScreenOnMobile?: boolean };

export const Modal = ({
  title,
  open,
  children,
  isFullScreenOnMobile = true,
  ...props
}: ModalProps) => {
  const screens = useBreakpoint();

  return (
    <StyledModal
      title={title}
      open={open}
      className={!screens.lg ? 'modal-mobile' : undefined}
      isFullScreenOnMobile={isFullScreenOnMobile}
      closeIcon={<CloseCircleFilled />}
      {...props}
    >
      {children}
    </StyledModal>
  );
};
